import { alpha, Skeleton, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type ScoreLoadingSkeletonProps = {
    tone?: "default" | "inverse";
};

/** Shared score-content placeholder for FOODS score cards and live edit previews. */
export const ScoreLoadingSkeleton = ({ tone = "default" }: ScoreLoadingSkeletonProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const backgroundColor = tone === "inverse" ? alpha(theme.custom.grey[100], 0.28) : theme.custom.grey[400];
    const skeletonSx = { backgroundColor };

    return (
        <Stack
            aria-busy="true"
            aria-label={t("scorecard.loading", "Loading score")}
            data-testid="score-loading-skeleton"
            gap={theme.spacing(2)}
            role="status"
            sx={{ minWidth: 0, width: "100%" }}
        >
            <Stack aria-hidden="true" gap={theme.spacing(1.5)}>
                <Stack alignItems="baseline" direction="row" gap={theme.spacing(1)}>
                    <Skeleton
                        animation="wave"
                        height={theme.spacing(7)}
                        sx={skeletonSx}
                        variant="rounded"
                        width={theme.spacing(15)}
                    />
                    <Skeleton
                        animation="wave"
                        height={theme.spacing(3)}
                        sx={skeletonSx}
                        variant="rounded"
                        width={theme.spacing(8)}
                    />
                </Stack>
                <Skeleton animation="wave" height={theme.spacing(4)} sx={skeletonSx} variant="rounded" width="100%" />
                <Skeleton animation="wave" height={theme.spacing(4)} sx={skeletonSx} variant="rounded" width="72%" />
            </Stack>
        </Stack>
    );
};
